module.exports = class CurrentLocation
  templates:
    currentLocationMarker: require '../current_location_marker.html.mustache'

  onNewLocationCallbacks: null
  shouldTriggerNewLocation: false
  watchPositionId: null
  errorCount: 0

  constructor: ({ @$el, @$error, @map }) ->
    @onNewLocationCallbacks = []
    @$el.click @watch
    @$error.click => @$error.fadeOut 'fast'

  setMap: (map) ->
    @map = map
    @centerMap()
    @createOrUpdateMarker()

  centerMap: ->
    coords = @get()
    return unless coords? and @map?
    @map.setCenter(new google.maps.LatLng coords.lat, coords.lon)

  showError: (text) ->
    @$error.text text
    @$error.fadeIn 'fast'

    @errorCount += 1
    _errorCount = @errorCount

    setTimeout (=>
      return unless _errorCount is @errorCount
      @$error.fadeOut 'fast'
    ), 10000

  errorHandler: (err) =>
    @$el.removeClass 'searching'
    @showError I18n.t('js.modules.offers_map.current_location.error.you_have_disabled_geolocation')
    @triggerNewLocation err

  triggerNewLocation: (err, position) ->
    cb(err, position) for cb in @onNewLocationCallbacks

  onNewLocation: (cb) ->
    @onNewLocationCallbacks.push cb

  createOrUpdateMarker: ->
    coords = @get()

    # Do not try to create or update the marker unless the map has been loaded.
    return unless coords? and @map? and google?.maps?

    currentPosition = new google.maps.LatLng coords.lat, coords.lon

    if @marker?
      @marker.setPosition currentPosition
    else
      @$marker = $ @templates.currentLocationMarker.render()

      @marker = new RichMarker
        position: currentPosition
        map: @map
        draggable: false
        shadow: false
        content: @$marker[0]

    @$marker.removeClass 'accuracy-30 accuracy-60 accuracy-90'

    accuracy = coords.accuracy

    if accuracy >= 30 and accuracy < 60
      @$marker.addClass 'accuracy-30'
    else if accuracy >= 60 and accuracy < 90
      @$marker.addClass 'accuracy-60'
    else
      @$marker.addClass 'accuracy-90'

  successHandler: (position) =>
    @$el.removeClass 'searching'
    @$el.addClass 'active'

    @coords =
      lat: position.coords.latitude
      lon: position.coords.longitude
      accuracy: position.accuracy

    if @shouldTriggerNewLocation
      # We only trigger a new position event the first time we get the location.
      # We then continue to watch for location changes and we update the marker position,
      # but without triggering a callback to move the map every time.
      @shouldTriggerNewLocation = false
      @centerMap()
      @triggerNewLocation null, { lat: position.coords.latitude, lon: position.coords.longitude }

    @createOrUpdateMarker()

  watch: =>
    if not navigator?.geolocation?
      return @showError(I18n.t('js.modules.offers_map.current_location.error.geolocation_not_supported'))

    @$el.addClass 'searching'
    @shouldTriggerNewLocation = true

    options =
      enableHighAccuracy: true
      timeout: 10000

    navigator.geolocation.clearWatch(@watchPositionId) if @watchPositionId?
    @watchPositionId = navigator.geolocation.watchPosition @successHandler, @errorHandler, options

  get: ->
    return null unless @watchPositionId? and @coords?
    @coords
